<template>
  <nav v-if="currentUser" class="no-print">
    <div class="nav_left">
      <slot>
      <ul>
        <!--NavItem v-for="(item, index) in props.navItems" :key=index :name="item.name" :route="item.to"></NavItem>-->
        <li v-for="(item, index) in trackedItems">
        <RouterLink
          activeClass="router-link-active"
          exactActiveClass="router-link-exact-active"
          :class="item.class"
        
          :to="item.to"
          :key="index"
          >{{ item.text }}</RouterLink
        >
        </li>
      </ul>
    </slot>
    </div>
    <div v-if="isTop" class="nav_right">
      <p>Logged in as : {{ currentUser }} | {{ currentEmail }} [{{ currentGroup }}]</p>
      <button class="button" @click="usersStore.logout">Logout</button>
    </div>
  </nav>
  <div class="debug">
    <p><b>Nav-bar debugging tracked items..</b></p>
    <ul>
      <li v-for="(item,index) in trackedItems">{{index}} - {{ item }}</li>
    </ul>
  </div>
</template>

<script setup lang="ts">
//TODO SPlit logout/banner from Nav-bar component!
//import NavItem from './Nav-item.vue';
import { computed } from 'vue';
import { useUserStore } from '@/stores'
import { storeToRefs } from 'pinia'
import { useNavTracker } from '@/composables/Nav-tracker'

const usersStore = useUserStore()
const { currentUser, currentEmail, currentGroup } = storeToRefs(usersStore)


const props = defineProps({
//  navItems: Array,
  isTop: { type: Boolean, default: false },
  isKillable: { type: Boolean, default: false},
  level : { type: Number, required : true}
})

const navItems = defineModel<Array<any>>('navItems');

const { trackedItems } = useNavTracker(navItems, props.level);

//to update active nav links, watch route:
/*const navs = computed(()=>{
  const path = route.path;
  const split = path.split('/');
  const matchName = split[props.level];

  return props.navItems.map(item =>{
    item.class =  item.text.toLowerCase() == matchName ? "nav-link router-link-active" : "nav-link router-link";
    return item;
  })
  


})*/

</script>

<style lang="css" scoped>

nav {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
}

ul {
  list-style-type: none;
  display: flex;
  flex-direction: row;
  margin: 0;
  padding: 0;
}

.nav-link,
span {
  padding: 0.75rem;
  font-size: 1.125rem;
  line-height: 1.75rem;
  color: white;
  font-weight: 500;
  text-decoration: none;
}

.nav-link:hover, span.clickable:hover {
  color: black;
}

.router-link-active {
  background-color: green;
  border: 1px solid white;
  font-weight: 900;
}

.router-link-exact-active {
  /*background-color: yellow;*/
}

div.nav_right {
  color: white;
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 2rem;
  padding-right: 1rem;
}

</style>
